<template>
  <div
    class="input-field"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
    :ref="name"
    v-show="viewConditions"
  >
    <i class="material-icons prefix" v-if="icon">{{ icon }}</i>

    <input
      v-if="type === 'text'"
      :id="`${name}_${type}`"
      type="text"
      v-model="fieldValue"
      :class="[fieldStyle.class, displayError]"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      
    />
    <!-- :autocomplete="autoComplete ? 'on' : 'off'" -->
    <input
      v-if="type === 'password'"
      :id="`${name}_${type}`"
      :type="showPassword ? 'text' : 'password'"
      v-model="fieldValue"
      :class="[fieldStyle.class, displayError]"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      v-bind:placeholder="placeholder ? placeholder : ''"
    />
    <button @click="$_showPassword()" v-if="type === 'password'" class="btn-floating btn-flat btn-small waves-effect transparent show-password">
      <i class="material-icons grey-text text-darken-2">{{showPassword ? 'visibility_off' : 'visibility'}}</i>
    </button>
    <!-- :autocomplete="autoComplete ? 'on' : 'off'" -->
    <input
      v-else-if="type === 'number'"
      :id="`${name}_${type}`"
      type="number"
      :min="minValue"
      step=".01"
      v-model="fieldValue"
      :class="[fieldStyle.class, displayError]"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      
    />
    <!-- :autocomplete="autoComplete ? 'on' : 'off'" -->
    <input
      v-else-if="type === 'email'"
      :id="`${name}_${type}`"
      type="email"
      v-model="fieldValue"
      :class="[fieldStyle.class, displayError]"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      
    />
    <label
      v-if="showLabel && type !== 'textarea'"
      :for="`${name}_${type}`"
      :class="{ active: fieldValue || placeholder }"
      >{{ label }}</label>

      
    <!-- :autocomplete="autoComplete ? 'on' : 'off'" -->
    <div class="label"
      v-if="showLabel && type === 'textarea'" v-html="label"></div>
<!--  -->
<div class="description" v-if="description" v-html="description"></div>
<!--  -->
    <textarea
      v-if="type === 'textarea'"
      :id="`${name}_${type}`"
      class="materialize-textarea"
      v-model="fieldValue"
      :class="[fieldStyle.class, displayError, !viewConditions ? 'disabled' : '']"
      :style="[fieldStyle.style]"
      :disabled="isDisabled"
      v-bind:placeholder="placeholder ? placeholder : ''"
    ></textarea>
    <!-- :autocomplete="autoComplete ? 'on' : 'off'" -->

    <span
      class="helper-text"
      :data-error="error"
      data-success="Correct"
      v-if="showHelperText"
      >{{ helperText }}</span
    >
  </div>
</template>

<script>
export default {
  name: "InputField",
  props: {
    viewConditions:{
      required: false,
    },
    minValue:{
      type: [Number],
      default: 0,
    },
    value: {
      type: [String, Number],
    },
    description:{
      type: [String, Boolean],
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    viewConditions: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    fieldType: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    showHelperText: {
      type: Boolean,
      default: () => true,
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      isTyping: false,
      showPassword: false,
      fieldValue: this.value,
    };
  },
  mounted() {
    this.addPlaceholder()
    this.addToGroup()
  },
  watch: {
    fieldValue: function(nV) {
      // this.allowOnlyNumber();
    
    if (this.fieldValue !== 'number') this.updateValue()
      if(this.type === 'number' && parseFloat(nV) < 0) {
        setTimeout(() => {
          this.fieldValue = ''
        }, 300);
      } else {
       this.updateValue()
      }
    },
  },
  computed: {
    displayError() {
      if (this.isTyping) {
        if (this.hasError && this.error) {
          return "invalid";
        } else {
          return "valid";
        }
      }
    },
  },
  methods: {
    $_showPassword () {
      this.showPassword 
      ? this.showPassword = false 
      : this.showPassword = true
    },
    addToGroup() {
      if (this.groupTag) {
        const groupId = `#${this.groupTag}`;
        const contentContainerId = `#${this.groupTag}_content`;
        // console.log(`${this.name} => belongs to ${this.groupTag} group`);

        const group = document.querySelector(groupId);

        const contentContainer = document.querySelector(contentContainerId);

        const groupItem = this.$refs[this.name];

        if (contentContainer) {
          contentContainer.appendChild(groupItem);
        } else {
          group.appendChild(groupItem);
        }
      }
    },
    addPlaceholder() {
      if (this.placeholder && this.type !== "textarea") {
        const el = this.$el.querySelector(`#${this.name}_${this.type}`);
        //console.log(el)
        el.placeholder = this.placeholder;
      }
    },
    allowOnlyNumber() {
      if (this.type === "number") {
        this.fieldValue = this.fieldValue.replace(/[^0-9]/g, "");
      }
    },
    updateValue(event) {
      this.isTyping = true;
      // console.log(error, hasError);
      this.$emit("update", this.fieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.show-password {
  position: absolute;
  right: 6px;
  top: 6px; 
}
</style>
